import whatInput from 'what-input'

const ESC_CODE = 27
whatInput.ignoreKeys([ESC_CODE])
